// Shared vocabulary for the Flagged Chats "Agent" dimension — the two synthetic agent IDs and
// how an agent is labelled and bucketed. Factored out of AgentAnalysisTab/FlaggedChatsPage/
// ThreadRow/flaggedChatsExport (which each had their own copy of the constants and the label
// branches) for the same reason as flagTypeColors.js: a third synthetic agent added to only
// one of them renders as a raw ID on the surfaces that were missed.

// Must match domain.ChatbotAgentID / domain.BotOnlyAgentID — the backend matches these against
// is_bot rather than a literal agent_id.
export const CHATBOT_AGENT_ID = 'chatbot';
export const BOT_ONLY_AGENT_ID = 'bot_only';

const SYNTHETIC_AGENT_LABELS = {
  [CHATBOT_AGENT_ID]: 'Chatbot',
  [BOT_ONLY_AGENT_ID]: '100% Bot-handled',
};

// Display name for an agent option: the synthetic entries get a human-readable label, real
// agents are shown by their raw ID (which is what reviewers recognise them by).
export const agentLabel = (agentID) => SYNTHETIC_AGENT_LABELS[agentID] || agentID;

// Bot status is tri-state, matching domain.ThreadAgentInfo.IsBot: true/false when the brand's
// warehouse classifies the agent, null/undefined when it doesn't. Unknown must not be
// collapsed into "human" — for an agent whose bot column exists but is unpopulated, that would
// attribute a bot-handled leg to a named human agent.
export const isBotAgent = (agent) => agent.is_bot === true;
export const isHumanAgent = (agent) => agent.is_bot === false;
export const isUnknownBotStatus = (agent) => agent.is_bot == null;

// The one-line caveat shown wherever bot attribution is displayed or filtered on, for a brand
// whose warehouse doesn't classify agents at all (GET /api/flagged-chats/agents reports this
// as bot_status_known: false). Without it, the absent Chatbot/100% Bot-handled filter options
// and the missing bot badges read as "no bot ever handled a flagged chat".
export const BOT_STATUS_UNKNOWN_NOTICE =
  'Per-agent bot detection is unavailable for this brand: its warehouse does not classify agents as bot or human yet, so the Chatbot / 100% Bot-handled filters and the bot badge are not shown.';

// Brand feature key for the conversation-length metrics (message/word counts, duration). A
// brand whose warehouse doesn't carry them (Cashy, on Pulse) lists `thread_metrics` under
// livechat_mining's `unsupported`, and the backend rejects sorting by them.
export const THREAD_METRICS_FEATURE = 'livechat_mining.thread_metrics';
